import React, {HTMLAttributes} from 'react';
import {theme} from './Common';

export type BlockProps = HTMLAttributes<HTMLDivElement>;

export function Block({...props}: BlockProps) {
  return (
    <div
      style={{
        fontFamily: theme.font.family,
        lineHeight: 1.5,
        width: '100%',
      }}
      {...props}
    />
  );
}
